document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    $(document).on("Searchanise.ResultsUpdated", function () {
      $('.snize-search-results .snize-product-out-of-stock').each(function() {
        $('button.snize-button', this).text('SOLD OUT').css('color', 'black');;
      });
      
      $(".snize-search-results .snize-product").each(function () {
        if (!$('.snize-reviews span', this).length) {
          $('.snize-reviews', this).append('<span class="stars-container stars-0">★★★★★</span>');
        }
      });
    });
  })(window.Searchanise.$);
});
